import { Region } from "../../hooks/react-query/linehaul/useRegions";

export const mockRegions = {
  default: [
    {
      id: 1,
      name: "EAST",
      serviceCenters: [],
    },
    {
      id: 2,
      name: "WEST",
      serviceCenters: [],
    },
    {
      id: 3,
      name: "MIDWEST",
      serviceCenters: [
        {
          id: 1,
          code: "ATM",
        },
        {
          id: 2,
          code: "CHT",
        },
        {
          id: 3,
          code: "IND-DAFG",
        },
        {
          id: 4,
          code: "IND-PITD",
        },
        {
          id: 5,
          code: "LRD",
        },
        {
          id: 6,
          code: "MDW-CXIT",
        },
        {
          id: 7,
          code: "MIS",
        },
        {
          id: 8,
          code: "OSH",
        },
      ],
    },
    {
      id: 4,
      name: "NORTHEAST",
      serviceCenters: [
        {
          id: 1,
          code: "BOS",
        },
        {
          id: 2,
          code: "CLE-PITD",
        },
        {
          id: 3,
          code: "EWR",
        },
        {
          id: 4,
          code: "WSH-PITD",
        },
      ],
    },
    {
      id: 5,
      name: "LAX/SFO/VIS",
      serviceCenters: [
        {
          id: 1,
          code: "LAX",
        },
        {
          id: 2,
          code: "SFO",
        },
        {
          id: 3,
          code: "VIS",
        },
      ],
    },
    {
      id: 6,
      name: "ONT",
      serviceCenters: [
        {
          id: 1,
          code: "ONT",
        },
      ],
    },
    {
      id: 135,
      name: "PM MIDWEST",
      serviceCenters: [
        {
          id: 1,
          code: "DAL",
        },
        {
          id: 2,
          code: "HTX",
        },
      ],
    },
    {
      id: 0,
      name: "Unassigned",
      serviceCenters: [
        {
          id: 1,
          code: "AFW",
        },
        {
          id: 2,
          code: "ATB-SEFL",
        },
        {
          id: 3,
          code: "ATL",
        },
        {
          id: 4,
          code: "AUB",
        },
        {
          id: 5,
          code: "BDL-RXIC",
        },
        {
          id: 6,
          code: "BWI",
        },
        {
          id: 7,
          code: "BWI-PDXE",
        },
        {
          id: 8,
          code: "CHT-AVRT",
        },
        {
          id: 9,
          code: "CLE-USCO",
        },
        {
          id: 10,
          code: "COL-USCO",
        },
        {
          id: 11,
          code: "CVG-ABNE",
        },
        {
          id: 12,
          code: "CVG-USCO",
        },
        {
          id: 13,
          code: "DAL-AGCE",
        },
        {
          id: 14,
          code: "DEN-DLDS",
        },
        {
          id: 15,
          code: "DFW",
        },
        {
          id: 16,
          code: "DFW-AGCE",
        },
        {
          id: 17,
          code: "DTW-DAFG",
        },
        {
          id: 18,
          code: "HVN",
        },
        {
          id: 19,
          code: "JAX",
        },
        {
          id: 20,
          code: "LIT-DHRN",
        },
        {
          id: 21,
          code: "LOU-DAFG",
        },
        {
          id: 22,
          code: "MIA-AVRT",
        },
        {
          id: 23,
          code: "NAS",
        },
        {
          id: 24,
          code: "NAS-AVRT",
        },
        {
          id: 25,
          code: "NJC-PYLE",
        },
        {
          id: 26,
          code: "ORH-RXIC",
        },
        {
          id: 27,
          code: "ORL",
        },
        {
          id: 28,
          code: "PDZ-DLDS",
        },
        {
          id: 29,
          code: "PER-DHRN",
        },
        {
          id: 30,
          code: "PGH-PYLE",
        },
        {
          id: 31,
          code: "PHX",
        },
        {
          id: 32,
          code: "PHX-ACDO",
        },
        {
          id: 33,
          code: "PHX-DDPP",
        },
        {
          id: 34,
          code: "PME",
        },
        {
          id: 35,
          code: "RIC-AVRT",
        },
        {
          id: 36,
          code: "SAT",
        },
        {
          id: 37,
          code: "SEA-DLDS",
        },
        {
          id: 38,
          code: "SFA-AFKI",
        },
        {
          id: 39,
          code: "SLC-DLDS",
        },
        {
          id: 40,
          code: "SYR-PYLE",
        },
        {
          id: 41,
          code: "TOR-SZTG",
        },
        {
          id: 42,
          code: "TUL-AGCE",
        },
        {
          id: 43,
          code: "WCH-PYLE",
        },
        {
          id: 44,
          code: "YRK-PYLE",
        },
      ],
    },
  ],
} as const satisfies Record<string, Region[]>;
